import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { ProductRepository } from '../repositories/ProductRepository';
import { IItemsParams } from '../../api/ProdcatApiSdk';
import { BroadcastProductsLoadedUseCase } from './BroadcastProductsLoadedUseCase';

export class LoadedProductsUseCase {
    private productRepository: ProductRepository;
    private itemParams: IItemsParams;
    private productIds: string[];

    constructor(itemParams: IItemsParams, productIds: string[]) {
        this.itemParams = itemParams;
        this.productIds = productIds;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = async () => {
        if (this.itemParams.items.length > 0) {
            const { items } = this.itemParams;
            const includeInnerHits = true;

            await this.productRepository.getProductsByIds(items, includeInnerHits);

            const broadcastProductsLoadedUseCase = new BroadcastProductsLoadedUseCase(
                this.productIds
            );
            broadcastProductsLoadedUseCase.execute();
        }
    };
}
